import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/subscriptions`;

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getSubscriptionApiError = (
  error,
  fallbackMessage = "Une erreur est survenue.",
) => error?.response?.data?.message || error?.message || fallbackMessage;

/*
 * GET — ancienne route conservée.
 * Retourne uniquement les abonnements.
 */
export const getAllSubscriptions = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/allSubscriptions`,
      getAuthConfig(),
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Erreur lors du chargement des abonnements :", error);

    /*
     * On conserve le comportement historique afin de ne pas
     * casser les anciens composants qui attendent un tableau.
     */
    return [];
  }
};

/*
 * Nouvelle route d’administration.
 * Retourne les abonnements et les prestations ponctuelles.
 */
export const getAllBillingItems = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/allBillingItems`,
      getAuthConfig(),
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors du chargement des abonnements et prestations :",
      error,
    );

    throw error;
  }
};

export const getSubscriptionDashboard = async ({
  months = 12,
  renewalDays = 30,
  product = "all",
} = {}) => {
  try {
    const params = {
      months,
      renewal_days: renewalDays,
    };

    /*
     * Le serveur n’applique ce filtre
     * qu’à l’historique du graphique.
     */
    if (product && product !== "all") {
      params.history_product = product;
    }

    const response = await axios.get(`${apiUrl}/dashboard`, {
      ...getAuthConfig(),
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du tableau de bord :", error);

    throw error;
  }
};

export const getSubscriptionById = async (id) => {
  try {
    const response = await axios.get(
      `${apiUrl}/subscriptionById/${id}`,
      getAuthConfig(),
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de l’abonnement :", error);

    throw error;
  }
};

/*
 * Ancienne route client.
 * Elle retourne uniquement les abonnements.
 */
export const getSubscriptionsByAssociation = async (associationId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/subscriptionsByAssociation/${associationId}`,
      getAuthConfig(),
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors du chargement des abonnements de l’association :",
      error,
    );

    throw error;
  }
};

/*
 * Nouvelle route client.
 * Elle retournera plus tard les abonnements et les prestations.
 */
export const getBillingItemsByAssociation = async (associationId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/billingItemsByAssociation/${associationId}`,
      getAuthConfig(),
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors du chargement des éléments de facturation :",
      error,
    );

    throw error;
  }
};

/*
 * POST
 */
export const saveSubscription = async (subscriptionData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addSubscription`,
      subscriptionData,
      getAuthConfig(),
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l’enregistrement :", error);

    throw error;
  }
};

/*
 * PATCH
 */
export const updateSubscription = async (id, subscriptionData) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updateSubscription/${id}`,
      subscriptionData,
      getAuthConfig(),
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour :", error);

    throw error;
  }
};

/*
 * DELETE
 */
export const deleteSubscription = async (id) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteSubscription/${id}`,
      getAuthConfig(),
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression :", error);

    throw error;
  }
};

export const getSubscriptionAlertsSummary =
  async () => {
    try {
      const response =
        await axios.get(
          `${apiUrl}/alerts-summary`,
          getAuthConfig(),
        );

      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors du chargement des alertes abonnements :",
        error,
      );

      throw error;
    }
  };
